import { Box, SxProps, Theme, Typography } from '@mui/material';

import { BackrsIcon, BackrsIcons } from './BackrsIcon';
import { appColors } from '../assets/appColors';

type BackrsListItemProps = Readonly<{
  title: string;
  rightIcon: { name: BackrsIcons; alt: string; color?: string };
  bottomBorder: boolean;
  onClick?: () => void;
}>;

export const BackrsListItem = ({
  title,
  rightIcon,
  bottomBorder,
  onClick,
}: BackrsListItemProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        ...listItemStyle,
        borderBottom: bottomBorder ? `1px solid ${appColors.color.taupe1}` : 'none',
      }}
    >
      <Typography variant="body1" fontSize={'11pt'} lineHeight={'16px'}>
        {title}
      </Typography>
      <Box sx={iconContainerStyle}>
        <BackrsIcon name={rightIcon.name} alt={rightIcon.alt} color={rightIcon.color} />
      </Box>
    </Box>
  );
};

const listItemStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 1.5,
  px: 1,
  width: '100%',
  backgroundColor: appColors.neutral.white,
  cursor: 'pointer',
};

const iconContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 36,
  ml: 1,
};
